/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useState, useEffect, useRef, useCallback } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

interface CustomDropdownProps {
	options: { label: string; value: string }[];
	onSelect: (selected: { label: string; value: string }) => void;
	initialValue?: { label: string; value: string };
}

const Dropdown: React.FC<CustomDropdownProps> = ({ options, onSelect, initialValue }) => {
	const [isTruncated, setIsTruncated] = useState(true);
	const timeoutRef = useRef<number>();
	const [selected, setSelected] = useState<{ label: string; value: string }>(
		initialValue || {
			label: "",
			value: "",
		}
	);

	const debounceResize = (callback: () => void, delay: number = 200) => {
		clearTimeout(timeoutRef.current);
		timeoutRef.current = window.setTimeout(callback, delay);
	};

	const updateWidth = useCallback(() => {
		setIsTruncated(window.outerWidth <= 350);
	}, []);

	useEffect(() => {
		debounceResize(updateWidth);
		window.addEventListener("resize", () => debounceResize(updateWidth));

		return () => {
			clearTimeout(timeoutRef.current);
			window.removeEventListener("resize", () => debounceResize(updateWidth));
		};
	}, []);

	return (
		<FormControl style={{ display: "flex", gap: "1rem", margin: "0", flexWrap: "wrap" }}>
			<Select
				fullWidth
				value={selected?.value}
				sx={{
					backgroundColor: "#f5f5f5",
					borderRadius: "8px",
					color: "#61607e",
					fontSize: "12px",
					fontWeight: 500,
					lineHeight: "16px",
					"& .MuiOutlinedInput-notchedOutline": {
						border: "none",
					},
					"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
						border: "none",
					},
				}}
				renderValue={(selectedValue) => {
					const item = options.find((o) => o.value === selectedValue);
					return isTruncated ? item?.label?.slice(0, 28) + "..." : item?.label;
				}}
				MenuProps={{
					PaperProps: {
						sx: {
							borderRadius: 2,
							maxHeight: 200,
							overflowX: "none",
							overflowY: "auto",
							scrollbarWidth: "thin",
						},
					},
				}}
			>
				{options?.map((elem) => (
					<MenuItem
						key={elem.value}
						value={elem.value}
						onClick={(e) => {
							const response = { label: elem?.label, value: elem?.value };
							setSelected(response);
							onSelect(response);
						}}
						sx={{
							color: "#61607e",
							fontSize: "12px",
							fontWeight: 500,
							lineHeight: "16px",
						}}
					>
						{elem?.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default Dropdown;
